<template>
    <div>
        <p>Escoge una canci&oacute;n de nuestro cat&aacute;logo</p>
    </div>
</template>
<script>

export default {
    name: 'Status'
};

</script>

<style scoped="">
div {
    color: orangered;
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #111;
    box-shadow: 0 0 15px #000;
}

div p {
    text-align: right;
    font-size: 12px;
    padding: 10px;
    margin: 0;
}
</style>